import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';


// ### jackie add begin

import { appConfig } from './app/app.config';// appConfig 要在 app component 之後
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
//appConfig.providers.push(provideRouter(routes));
// ### jackie add end

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
